import React, { useState } from "react";
import { useNavigate, useSearchParams, Link } from "react-router-dom";
import api from "@/lib/api";
import { Sparkles, Check } from "lucide-react";

const ResetPassword = () => {
  const [params] = useSearchParams();
  const token = params.get("token") || "";
  const [password, setPassword] = useState("");
  const [confirm, setConfirm] = useState("");
  const [loading, setLoading] = useState(false);
  const [done, setDone] = useState(false);
  const [error, setError] = useState("");
  const navigate = useNavigate();

  const submit = async (e) => {
    e.preventDefault();
    setError("");
    if (password !== confirm) { setError("Passwords don't match."); return; }
    setLoading(true);
    try {
      await api.post("/auth/reset-password", { token, new_password: password });
      setDone(true);
    } catch (err) {
      setError(err?.response?.data?.detail || "Could not reset your password.");
    } finally { setLoading(false); }
  };

  return (
    <div className="min-h-screen flex items-center justify-center p-6">
      <div className="w-full max-w-md glass rounded-2xl p-8 animate-fade-up">
        <div className="flex items-center gap-2 mb-6 justify-center">
          <div className="w-9 h-9 rounded-xl bg-gradient-to-br from-primary to-secondary flex items-center justify-center"><Sparkles className="w-5 h-5 text-white" /></div>
          <span className="gifted-brand text-2xl">GIFTED</span>
        </div>
        {!token ? (
          <p className="text-center text-sm text-red-400" data-testid="reset-no-token">This reset link is missing its token. Please request a new one.</p>
        ) : done ? (
          <div className="text-center space-y-3" data-testid="reset-success">
            <div className="w-12 h-12 mx-auto rounded-full bg-secondary/15 flex items-center justify-center"><Check className="w-6 h-6 text-secondary" /></div>
            <p className="text-sm text-foreground/90">Your password has been reset.</p>
            <button onClick={() => navigate("/login")} className="w-full bg-gradient-to-r from-primary to-secondary text-white font-medium rounded-lg py-3 hover:opacity-90">Sign in</button>
          </div>
        ) : (
          <form onSubmit={submit} className="space-y-4">
            <h2 className="font-serif text-3xl mb-1 text-center">Set a new password</h2>
            <input data-testid="reset-password" type="password" required minLength={6} value={password} onChange={(e) => setPassword(e.target.value)}
              className="w-full bg-input border border-border rounded-lg px-4 py-2.5 focus:outline-none focus:ring-2 focus:ring-primary/50" placeholder="New password" />
            <input data-testid="reset-password-confirm" type="password" required minLength={6} value={confirm} onChange={(e) => setConfirm(e.target.value)}
              className="w-full bg-input border border-border rounded-lg px-4 py-2.5 focus:outline-none focus:ring-2 focus:ring-primary/50" placeholder="Confirm new password" />
            {error && <div data-testid="reset-error" className="text-sm text-red-400 bg-red-500/10 border border-red-500/20 rounded-lg px-3 py-2">{error}</div>}
            <button data-testid="reset-submit" type="submit" disabled={loading}
              className="w-full bg-gradient-to-r from-primary to-secondary text-white font-medium rounded-lg py-3 hover:opacity-90 disabled:opacity-50">
              {loading ? "Resetting…" : "Reset password"}
            </button>
          </form>
        )}
        <div className="mt-6 text-center text-sm text-muted-foreground">
          <Link to="/login" className="text-primary hover:underline font-medium">Back to Sign In</Link>
        </div>
      </div>
    </div>
  );
};

export default ResetPassword;
